<template>
  <div>
    <v-breadcrumbs :items="breadcrumbItems" />
    <Inspection :asset-meta-index="assetMetaIndex" :inspection-config="inspectionConfig" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Inspection from './Inspection.vue';

export default {
  name: 'InspectionContainer',
  components: {
    Inspection,
  },
  computed: mapGetters({
    breadcrumbItems: 'breadcrumb/items',
    assetMetaIndex: 'config/assetMetaIndex',
    inspectionConfig: 'config/inspectionConfig',
  }),
  watch: {
    // ToDo: change to push new routes
    '$route.params': function () {
      this.initialiseBreadcrumb();
    },
  },
  created() {
    this.loadMetricData(this.$route.query.id);
    this.initialiseBreadcrumb();
  },
  methods: mapActions({
    initialiseBreadcrumb: 'breadcrumb/initialise',
    loadMetricData: 'config/loadMetricData',
  }),
};
</script>
